import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-noti-bell',
  templateUrl: './noti-bell.component.html',
  styleUrls: ['./noti-bell.component.scss'],
})
export class NotiBellComponent implements OnInit {

  constructor() { }
  notificationList:any = [];
  ngOnInit() {
    this.notificationList = [ 
      {
        message:"En el curso Artes 4A se ha inscrito un nuevo estudiante",
        icon:"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAAAAAAALAAAAAABAAEAAAICTAEAOw=="
      },
      {
        message:"En el curso Matemáticas 4A se ha inscrito un nuevo estudiante",
        icon:"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAAAAAAALAAAAAABAAEAAAICTAEAOw=="
      },
      {
        message:"En el curso Química Avanzada se ha inscrito un nuevo estudiante",
        icon:"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAAAAAAALAAAAAABAAEAAAICTAEAOw=="
      }
    ];
  }

}
